// BotanicalCollector — product page interactions
// === Product gallery ===
window.galleryGo = function(n, options) {
  if (typeof options === 'boolean') {
    options = { instant: options };
  }
  window._galleryIndex = n;
  updateGallery(options || {});
};
window.galleryNext = function() {
  var total = parseInt(window._galleryTotal || 1);
  window._galleryIndex = ((window._galleryIndex || 0) + 1) % total;
  updateGallery({});
};
window.galleryPrev = function() {
  var total = parseInt(window._galleryTotal || 1);
  window._galleryIndex = ((window._galleryIndex || 0) - 1 + total) % total;
  updateGallery({});
};

function setGalleryMediaLoaded(element) {
  if (!element) return;
  var shell = element.closest('[data-gallery-media-shell], [data-gallery-thumb-shell]');
  if (!shell) return;
  shell.classList.remove('is-loading');
  shell.classList.add('is-loaded');
}

function setGalleryMediaLoading(element) {
  if (!element) return;
  var shell = element.closest('[data-gallery-media-shell], [data-gallery-thumb-shell]');
  if (!shell) return;
  shell.classList.add('is-loading');
  shell.classList.remove('is-loaded');
}

function bindGalleryMediaLoadState(shell) {
  if (!shell || shell.dataset.galleryLoadBound === 'true') return;
  shell.dataset.galleryLoadBound = 'true';

  var image = shell.querySelector('[data-gallery-image], [data-gallery-thumb-image]');
  if (image) {
    if (image.complete && image.naturalWidth > 0) {
      setGalleryMediaLoaded(image);
    } else {
      image.addEventListener('load', function() { setGalleryMediaLoaded(image); });
      image.addEventListener('error', function() { setGalleryMediaLoaded(image); });
    }
    return;
  }

  var video = shell.querySelector('video');
  if (video) {
    video.addEventListener('loadedmetadata', function() { setGalleryMediaLoaded(video); });
    video.addEventListener('loadeddata', function() { setGalleryMediaLoaded(video); });
    if (video.readyState >= 1) {
      setGalleryMediaLoaded(video);
    } else if (video.poster) {
      var poster = new Image();
      poster.onload = function() { setGalleryMediaLoaded(video); };
      poster.onerror = function() { setGalleryMediaLoaded(video); };
      poster.src = video.poster;
    }
    return;
  }

  var iframe = shell.querySelector('iframe');
  if (iframe) {
    iframe.addEventListener('load', function() {
      if (iframe.src && iframe.src !== 'about:blank') setGalleryMediaLoaded(iframe);
    });
    if (iframe.src && iframe.src !== 'about:blank') {
      // The load event remains authoritative; this only prevents a blank shell
      // when a cached embed completed before the deferred product script ran.
      window.setTimeout(function() {
        if (iframe.src && iframe.src !== 'about:blank') setGalleryMediaLoaded(iframe);
      }, 800);
    }
    return;
  }

  var modelViewer = shell.querySelector('model-viewer');
  if (modelViewer) {
    modelViewer.addEventListener('load', function() { setGalleryMediaLoaded(modelViewer); });
    var modelPoster = modelViewer.getAttribute('poster');
    if (modelPoster) {
      var modelPosterImage = new Image();
      modelPosterImage.onload = function() { setGalleryMediaLoaded(modelViewer); };
      modelPosterImage.onerror = function() { setGalleryMediaLoaded(modelViewer); };
      modelPosterImage.src = modelPoster;
    }
  }
}

function initProductGalleryMediaLoading(root) {
  if (!root) return;
  root.querySelectorAll('[data-gallery-media-shell], [data-gallery-thumb-shell]').forEach(bindGalleryMediaLoadState);
}

function prepareGallerySlide(index) {
  var slide = document.querySelector('[data-gallery-slide][data-gallery-index="' + index + '"]');
  if (!slide) return;

  var image = slide.querySelector('[data-gallery-image]');
  if (image) {
    image.loading = 'eager';
    image.fetchPriority = 'high';
    if (image.complete && image.naturalWidth > 0) setGalleryMediaLoaded(image);
  }

  var video = slide.querySelector('video');
  if (video && video.preload !== 'metadata') {
    setGalleryMediaLoading(video);
    video.preload = 'metadata';
    video.load();
  }

  var iframe = slide.querySelector('iframe[data-gallery-src]');
  if (iframe && (!iframe.src || iframe.src === 'about:blank')) {
    setGalleryMediaLoading(iframe);
    iframe.src = iframe.getAttribute('data-gallery-src');
  }
}

function prefetchAdjacentGalleryImage(index) {
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) return;

  var total = parseInt(window._galleryTotal || '1', 10);
  if (total < 2) return;
  var nextIndex = (index + 1) % total;
  var nextSlide = document.querySelector('[data-gallery-slide][data-gallery-index="' + nextIndex + '"]');
  var nextImage = nextSlide && nextSlide.querySelector('[data-gallery-image]');
  if (!nextImage) return;
  nextImage.loading = 'eager';
  nextImage.fetchPriority = 'low';
}

function pauseInactiveGalleryMedia(activeIndex) {
  var slides = document.querySelectorAll('[data-gallery-slide]');
  slides.forEach(function(slide, idx) {
    var isActive = idx === activeIndex;
    slide.querySelectorAll('video').forEach(function(video) {
      if (!isActive) {
        video.pause();
      }
    });
    slide.querySelectorAll('iframe').forEach(function(iframe) {
      var savedSrc = iframe.getAttribute('data-gallery-src');
      if (!savedSrc && iframe.src && iframe.src !== 'about:blank') {
        iframe.setAttribute('data-gallery-src', iframe.src);
        savedSrc = iframe.src;
      }
      if (!isActive && savedSrc && !iframe.hasAttribute('data-gallery-seo-video')) {
        setGalleryMediaLoading(iframe);
        iframe.src = 'about:blank';
      } else if (isActive && savedSrc && iframe.src === 'about:blank') {
        setGalleryMediaLoading(iframe);
        iframe.src = savedSrc;
      }
    });
  });
}

function updateGallery(options) {
  options = options || {};
  var i = window._galleryIndex || 0;
  var track = document.getElementById('galleryTrack');
  if (track) {
    if (options.instant) track.style.transition = 'none';
    track.style.transform = 'translateX(-' + (i * 100) + '%)';
    if (options.instant) {
      void track.offsetWidth;
      track.style.transition = '';
    }
  }
  document.querySelectorAll('[data-gallery-thumb]').forEach(function(t, idx) {
    t.classList.toggle('is-active', idx === i);
  });
  prepareGallerySlide(i);
  pauseInactiveGalleryMedia(i);
  prefetchAdjacentGalleryImage(i);
  if (!options.skipVariantSync) {
    syncVariantFromGalleryIndex(i);
  }
  ensureGalleryThumbVisible(i, { instant: options.instant });
  var stage = document.querySelector('.product-gallery__stage');
  var slides = document.querySelectorAll('[data-gallery-slide]');
  if (stage && slides[i]) {
    var mediaType = slides[i].getAttribute('data-media-type');
    stage.classList.toggle('has-video-controls', mediaType === 'video' || mediaType === 'external_video');
  }
}

function getCurrentProductVariant() {
  var data = getProductVariantsData();
  if (!data || !data.variants || !data.variants.length) return null;
  var variantId = getSelectedProductVariantId();
  return data.variants.find(function(v) { return v.id === variantId; }) || data.variants[0];
}

function productPageIsB2b() {
  var data = getProductVariantsData();
  return !!(data && data.is_b2b);
}

function getProductQtyBounds(variant) {
  variant = variant || getCurrentProductVariant();
  var rule = (variant && variant.quantity_rule) || {};
  var min = parseInt(rule.min, 10) || 1;
  var increment = parseInt(rule.increment, 10) || 1;

  // Ceiling only from Shopify quantity_rule.max and/or tracked inventory.
  // If neither applies → no storefront limit.
  var ruleMax = null;
  if (rule.max != null && rule.max !== '') {
    ruleMax = parseInt(rule.max, 10);
    if (isNaN(ruleMax)) ruleMax = null;
  }

  var stockMax = null;
  if (variant && variant.inventory_tracked) {
    var stock = parseInt(variant.inventory_quantity, 10);
    if (!isNaN(stock)) stockMax = stock;
  }

  var max = null;
  if (ruleMax != null && stockMax != null) max = Math.min(ruleMax, stockMax);
  else if (ruleMax != null) max = ruleMax;
  else if (stockMax != null) max = stockMax;
  else max = Number.MAX_SAFE_INTEGER;

  if (max < min) max = min;
  return { min: min, max: max, increment: increment };
}

function getProductQty() {
  var el = document.getElementById('qtyNum');
  if (!el) return 1;
  return parseInt(el.value != null ? el.value : el.textContent, 10) || 1;
}

function setProductQty(qty) {
  var el = document.getElementById('qtyNum');
  var input = document.getElementById('qtyInput');
  var bounds = getProductQtyBounds();
  var next = parseInt(qty, 10);
  if (isNaN(next)) next = bounds.min;
  if (next < bounds.min) next = bounds.min;
  if (next > bounds.max) next = bounds.max;
  var offset = next - bounds.min;
  if (bounds.increment > 1) {
    next = bounds.min + Math.round(offset / bounds.increment) * bounds.increment;
    if (next > bounds.max) next = bounds.min + Math.floor((bounds.max - bounds.min) / bounds.increment) * bounds.increment;
    if (next < bounds.min) next = bounds.min;
  }
  if (el) {
    if (el.tagName === 'INPUT') {
      el.value = String(next);
      el.min = String(bounds.min);
      if (bounds.max < Number.MAX_SAFE_INTEGER) el.max = String(bounds.max);
      else el.removeAttribute('max');
      el.step = String(bounds.increment || 1);
    } else {
      el.textContent = String(next);
    }
  }
  if (input && input.value !== String(next)) {
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  updateVolumePricing();
  syncSeedPromoQtyState();
}

function syncSeedPromoQtyState() {
  var root = document.querySelector('.product-seed-promos');
  if (!root) return;
  var qty = getProductQty();
  var buttons = root.querySelectorAll('[data-seed-promo-qty]');
  for (var i = 0; i < buttons.length; i++) {
    var btn = buttons[i];
    var target = parseInt(btn.getAttribute('data-seed-promo-qty'), 10);
    if (!isNaN(target) && target === qty) btn.classList.add('is-active');
    else btn.classList.remove('is-active');
  }
}

function initSeedPromoQty() {
  var root = document.querySelector('.product-seed-promos');
  if (!root || root.dataset.seedPromoBound === 'true') return;
  root.dataset.seedPromoBound = 'true';
  root.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-seed-promo-qty]');
    if (!btn || !root.contains(btn)) return;
    var qty = parseInt(btn.getAttribute('data-seed-promo-qty'), 10);
    if (isNaN(qty) || qty < 1) return;
    setProductQty(qty);
    var qtyEl = document.getElementById('qtyNum');
    if (qtyEl && typeof qtyEl.focus === 'function') qtyEl.focus();
  });
  syncSeedPromoQtyState();
}

function initProductQtyInput() {
  var el = document.getElementById('qtyNum');
  if (!el || el.tagName !== 'INPUT' || el.dataset.qtyBound === 'true') return;
  el.dataset.qtyBound = 'true';
  function commit() {
    setProductQty(el.value);
  }
  el.addEventListener('change', commit);
  el.addEventListener('blur', commit);
  el.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      commit();
      el.blur();
    }
  });
}

function volumeTiersForVariant(variant) {
  if (!variant) return [];
  var minQty = parseInt(variant.quantity_rule && variant.quantity_rule.min, 10) || 1;
  var breaks = (variant.quantity_price_breaks || []).slice().sort(function(a, b) {
    return Number(a.minimum_quantity) - Number(b.minimum_quantity);
  });
  var tiers = [];
  var hasBaseBreak = breaks.some(function(item) {
    return Number(item.minimum_quantity) === minQty;
  });
  if (!hasBaseBreak) {
    tiers.push({
      min: minQty,
      price_formatted: variant.price_formatted,
      price_money: variant.price_money
    });
  }
  breaks.forEach(function(item) {
    tiers.push({
      min: Number(item.minimum_quantity),
      price_formatted: item.price_formatted,
      price_money: item.price_money
    });
  });
  return tiers;
}

function formatVolumeQtyRange(min) {
  return min + '+';
}

function volumePriceUnit() {
  if (document.querySelector('.model-pdp')) return ' / piece';
  var data = getProductVariantsData();
  if (data && data.is_seed) return ' / seed';
  return ' / plant';
}

function renderVolumePricing() {
  var wrap = document.getElementById('productVolume');
  var list = document.getElementById('productVolumeList');
  var variant = getCurrentProductVariant();
  if (!wrap || !list) return;
  var tiers = volumeTiersForVariant(variant);
  if (!productPageIsB2b() || !tiers.length || !(variant && variant.quantity_price_breaks && variant.quantity_price_breaks.length)) {
    wrap.hidden = true;
    list.textContent = '';
    return;
  }
  wrap.hidden = false;
  list.textContent = '';
  tiers.forEach(function(tier) {
    var row = document.createElement('li');
    row.className = 'product-volume__row';
    row.setAttribute('data-volume-min', String(tier.min));
    row.setAttribute('data-price-formatted', tier.price_formatted || '');
    var qtyEl = document.createElement('span');
    qtyEl.textContent = formatVolumeQtyRange(tier.min);
    var priceEl = document.createElement('span');
    priceEl.textContent = (tier.price_money || ('$' + (tier.price_formatted || ''))) + volumePriceUnit();
    row.appendChild(qtyEl);
    row.appendChild(priceEl);
    list.appendChild(row);
  });
  updateVolumePricing();
}

function updateVolumePricing() {
  var list = document.getElementById('productVolumeList');
  var priceEl = document.getElementById('productPrice');
  var variant = getCurrentProductVariant();
  var qty = getProductQty();
  var rows = list ? Array.prototype.slice.call(list.querySelectorAll('.product-volume__row')) : [];
  var activeFormatted = variant && variant.price_formatted;
  var activeMin = -1;
  rows.forEach(function(row) {
    var min = parseInt(row.getAttribute('data-volume-min'), 10);
    if (!isNaN(min) && qty >= min && min >= activeMin) {
      activeMin = min;
      activeFormatted = row.getAttribute('data-price-formatted') || activeFormatted;
    }
  });
  rows.forEach(function(row) {
    var min = parseInt(row.getAttribute('data-volume-min'), 10);
    row.classList.toggle('is-active', min === activeMin);
  });
  if (priceEl && activeFormatted) priceEl.textContent = activeFormatted;
}

// === Qty buttons ===
window.qtyInc = function() {
  var bounds = getProductQtyBounds();
  setProductQty(getProductQty() + bounds.increment);
};
window.qtyDec = function() {
  var bounds = getProductQtyBounds();
  setProductQty(getProductQty() - bounds.increment);
};

function initBuyNow() {
  var buyBtn = document.getElementById('productBuyBtn');
  var errorEl = document.getElementById('productBuyError');
  if (!buyBtn) return;

  var buyLabel = buyBtn.textContent;
  var busy = false;
  buyBtn.addEventListener('click', async function() {
    if (busy || buyBtn.disabled || buyBtn.hidden) return;
    var variant = getCurrentProductVariant();
    var variantId = getSelectedProductVariantId();
    var quantity = getProductQty();
    if (!variant || !variant.available || variant.id !== variantId || quantity < 1) return;

    busy = true;
    if (errorEl) errorEl.hidden = true;
    buyBtn.disabled = true;
    buyBtn.setAttribute('aria-busy', 'true');
    buyBtn.textContent = buyBtn.getAttribute('data-processing-label') || buyLabel;

    var input = {
      lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: quantity }]
    };
    var countryCode = buyBtn.getAttribute('data-buyer-country');
    if (/^[A-Z]{2}$/.test(countryCode || '')) input.buyerIdentity = { countryCode: countryCode };

    try {
      var response = await fetch('/api/2026-07/graphql.json', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query: 'mutation BuyNowCartCreate($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl lines(first: 1) { nodes { quantity merchandise { ... on ProductVariant { id } } } } } userErrors { message } } }',
          variables: { input: input }
        })
      });
      if (!response.ok) throw new Error('Checkout request failed');
      var result = await response.json();
      var created = result && result.data && result.data.cartCreate;
      var cart = created && created.cart;
      var line = cart && cart.lines && cart.lines.nodes && cart.lines.nodes[0];
      if ((result.errors && result.errors.length) || !cart || (created.userErrors && created.userErrors.length) ||
          !line || line.quantity !== quantity || !line.merchandise || line.merchandise.id !== input.lines[0].merchandiseId ||
          getSelectedProductVariantId() !== variantId || getProductQty() !== quantity) {
        throw new Error('Checkout cart did not match the selection');
      }
      var checkoutUrl = new URL(cart.checkoutUrl);
      if (checkoutUrl.protocol !== 'https:') throw new Error('Invalid checkout URL');
      window.location.assign(checkoutUrl.href);
    } catch (error) {
      busy = false;
      buyBtn.textContent = buyLabel;
      buyBtn.removeAttribute('aria-busy');
      var currentVariant = getCurrentProductVariant();
      buyBtn.disabled = !(currentVariant && currentVariant.available);
      if (errorEl) errorEl.hidden = false;
    }
  });
}

function getProductVariantGalleryIndex() {
  var data = getProductVariantsData();
  if (!data || !data.variants || !data.variants.length) return 0;
  var variantId = getSelectedProductVariantId();
  var variant = data.variants.find(function(v) { return v.id === variantId; });
  if (!variant) return 0;
  var idx = variant.featured_media_index;
  var total = parseInt(window._galleryTotal || '1', 10);
  return Math.max(0, Math.min(idx, total - 1));
}

function setGalleryThumbsExpanded(expanded) {
  var thumbs = document.getElementById('productGalleryThumbs');
  var toggle = document.querySelector('[data-gallery-thumbs-toggle]');
  if (!thumbs || !toggle) return;
  thumbs.classList.toggle('is-expanded', expanded);
  toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  var moreLabel = toggle.querySelector('[data-gallery-thumbs-more]');
  var lessLabel = toggle.querySelector('[data-gallery-thumbs-less]');
  if (moreLabel) moreLabel.hidden = expanded;
  if (lessLabel) lessLabel.hidden = !expanded;
}

function ensureGalleryThumbVisible(index, options) {
  options = options || {};
  var thumbs = document.getElementById('productGalleryThumbs');
  if (!thumbs) return;

  if (thumbs.classList.contains('product-gallery__thumbs--collapsible')) {
    var limit = parseInt(thumbs.getAttribute('data-thumb-limit') || '8', 10);
    if (index >= limit && !thumbs.classList.contains('is-expanded')) {
      setGalleryThumbsExpanded(true);
    }
  }

  var active = thumbs.querySelector('[data-gallery-thumb][data-gallery-index="' + index + '"]');
  if (!active) active = thumbs.querySelectorAll('[data-gallery-thumb]')[index];
  if (!active) return;

  var modelGallery = !!thumbs.closest('.model-pdp');
  var maxScrollX = thumbs.scrollWidth - thumbs.clientWidth;
  var maxScrollY = thumbs.scrollHeight - thumbs.clientHeight;
  if (maxScrollX <= 1 && (!modelGallery || maxScrollY <= 1)) return;

  var wrapRect = thumbs.getBoundingClientRect();
  var thumbRect = active.getBoundingClientRect();
  var behavior = options.instant ? 'auto' : 'smooth';

  if (modelGallery && maxScrollY > 1 && maxScrollY >= maxScrollX) {
    var targetScrollY = thumbs.scrollTop + (thumbRect.top + thumbRect.height / 2) - (wrapRect.top + wrapRect.height / 2);
    targetScrollY = Math.max(0, Math.min(maxScrollY, targetScrollY));
    if (typeof thumbs.scrollTo === 'function') {
      thumbs.scrollTo({ top: targetScrollY, behavior: behavior });
    } else {
      thumbs.scrollTop = targetScrollY;
    }
    return;
  }

  if (maxScrollX <= 1) return;
  var targetScroll = thumbs.scrollLeft + (thumbRect.left + thumbRect.width / 2) - (wrapRect.left + wrapRect.width / 2);
  targetScroll = Math.max(0, Math.min(maxScrollX, targetScroll));
  if (typeof thumbs.scrollTo === 'function') {
    thumbs.scrollTo({ left: targetScroll, behavior: behavior });
  } else {
    thumbs.scrollLeft = targetScroll;
  }
}

function initProductGalleryThumbsToggle() {
  var toggle = document.querySelector('[data-gallery-thumbs-toggle]');
  if (!toggle) return;
  toggle.addEventListener('click', function() {
    var thumbs = document.getElementById('productGalleryThumbs');
    var expanded = thumbs && thumbs.classList.contains('is-expanded');
    setGalleryThumbsExpanded(!expanded);
  });
}

// Edge-fade hint: show a fade on the right/left only when there is more to scroll.
function initProductGalleryThumbsScrollHint() {
  var thumbs = document.getElementById('productGalleryThumbs');
  if (!thumbs) return;
  var wrap = thumbs.parentElement;
  if (!wrap || !wrap.classList.contains('product-gallery__thumbs-wrap')) {
    wrap = thumbs.closest('.product-gallery__thumbs-wrap');
  }
  if (!wrap) return;
  var scrollbar = wrap.querySelector('[data-gallery-thumb-scrollbar]');
  var scrollbarHandle = wrap.querySelector('[data-gallery-thumb-scrollbar-handle]');

  function update() {
    if (!scrollbar || !scrollbarHandle) return;
    var trackWidth = scrollbar.clientWidth;
    var maxScroll = Math.max(thumbs.scrollWidth - thumbs.clientWidth, 0);
    var visibleRatio = thumbs.scrollWidth > 0 ? Math.min(thumbs.clientWidth / thumbs.scrollWidth, 1) : 1;
    var handleWidth = maxScroll > 0 ? Math.max(trackWidth * visibleRatio, 36) : trackWidth;
    handleWidth = Math.min(handleWidth, trackWidth);
    var handleTravel = Math.max(trackWidth - handleWidth, 0);
    var handleOffset = maxScroll > 0 ? (thumbs.scrollLeft / maxScroll) * handleTravel : 0;
    scrollbarHandle.style.width = handleWidth + 'px';
    scrollbarHandle.style.transform = 'translateX(' + handleOffset + 'px)';
  }

  if (scrollbar && scrollbarHandle) {
    var dragStartX = 0;
    var dragStartScroll = 0;
    var isDragging = false;

    scrollbar.addEventListener('pointerdown', function(e) {
      var maxScroll = Math.max(thumbs.scrollWidth - thumbs.clientWidth, 0);
      if (maxScroll <= 0) return;

      if (e.target !== scrollbarHandle) {
        var trackRect = scrollbar.getBoundingClientRect();
        var handleRect = scrollbarHandle.getBoundingClientRect();
        var targetRatio = (e.clientX - trackRect.left - handleRect.width / 2) / Math.max(trackRect.width - handleRect.width, 1);
        thumbs.scrollLeft = Math.min(Math.max(targetRatio, 0), 1) * maxScroll;
        update();
      }

      isDragging = true;
      dragStartX = e.clientX;
      dragStartScroll = thumbs.scrollLeft;
      scrollbar.setPointerCapture(e.pointerId);
      e.preventDefault();
    });

    scrollbar.addEventListener('pointermove', function(e) {
      if (!isDragging) return;
      var maxScroll = Math.max(thumbs.scrollWidth - thumbs.clientWidth, 0);
      var trackWidth = scrollbar.clientWidth;
      var handleWidth = scrollbarHandle.getBoundingClientRect().width;
      var handleTravel = Math.max(trackWidth - handleWidth, 1);
      thumbs.scrollLeft = dragStartScroll + (e.clientX - dragStartX) * (maxScroll / handleTravel);
    });

    function stopDragging(e) {
      if (!isDragging) return;
      isDragging = false;
      if (scrollbar.hasPointerCapture(e.pointerId)) scrollbar.releasePointerCapture(e.pointerId);
    }

    scrollbar.addEventListener('pointerup', stopDragging);
    scrollbar.addEventListener('pointercancel', stopDragging);
  }

  function recenter() {
    update();
    ensureGalleryThumbVisible(window._galleryIndex || 0, { instant: true });
  }

  update();
  thumbs.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', recenter);
  if ('ResizeObserver' in window) {
    var thumbsResizeObserver = new ResizeObserver(recenter);
    thumbsResizeObserver.observe(wrap);
  }
}

// Collapsible content blocks (mobile): "Show more / Show less" toggle.
function initModelPanels(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('[data-model-panel]').forEach(function(panel) {
    if (panel.getAttribute('data-model-panel-ready') === 'true') return;
    var summary = panel.querySelector('.model-panel__summary');
    var drawer = panel.querySelector('[data-model-panel-drawer]');
    if (!summary || !drawer) return;
    panel.setAttribute('data-model-panel-ready', 'true');

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var onEnd = null;

    function clearEnd() {
      if (!onEnd) return;
      drawer.removeEventListener('transitionend', onEnd);
      onEnd = null;
    }

    summary.addEventListener('click', function(event) {
      event.preventDefault();
      var opening = !panel.classList.contains('is-open');
      clearEnd();

      if (reduceMotion.matches) {
        panel.classList.toggle('is-open', opening);
        panel.open = opening;
        drawer.style.height = opening ? 'auto' : '0px';
        return;
      }

      if (!opening && drawer.scrollHeight === 0) {
        panel.classList.remove('is-open');
        panel.open = false;
        drawer.style.height = '0px';
        return;
      }

      if (opening) {
        panel.open = true;
        panel.classList.add('is-open');
        var start = drawer.getBoundingClientRect().height;
        drawer.style.height = 'auto';
        var target = drawer.scrollHeight;
        drawer.style.height = start + 'px';
        drawer.offsetHeight;
        drawer.style.height = target + 'px';
      } else {
        panel.classList.remove('is-open');
        var start = drawer.getBoundingClientRect().height;
        if (start === 0) {
          panel.open = false;
          drawer.style.height = '0px';
          return;
        }
        drawer.style.height = start + 'px';
        drawer.offsetHeight;
        drawer.style.height = '0px';
      }

      onEnd = function(e) {
        if (e.target !== drawer || e.propertyName !== 'height') return;
        clearEnd();
        if (panel.classList.contains('is-open')) {
          drawer.style.height = 'auto';
        } else {
          panel.open = false;
        }
      };
      drawer.addEventListener('transitionend', onEnd);
    });
  });
}

function initModelRelated(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('[data-model-related]').forEach(function(section) {
    if (section.getAttribute('data-model-related-ready') === 'true') return;
    section.setAttribute('data-model-related-ready', 'true');

    var track = section.querySelector('[data-model-related-track]');
    var sets = section.querySelectorAll('.model-related__set');
    if (!track || sets.length < 2) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobile = window.matchMedia('(max-width: 768px)');

    function syncMarquee() {
      if (reduceMotion.matches || mobile.matches) {
        section.classList.remove('is-marquee');
        track.style.removeProperty('--model-related-duration');
        return;
      }
      var setWidth = sets[0].scrollWidth;
      if (setWidth < 40) {
        section.classList.remove('is-marquee');
        return;
      }
      var seconds = Math.max(28, Math.round(setWidth / 28));
      track.style.setProperty('--model-related-duration', seconds + 's');
      section.classList.add('is-marquee');
    }

    syncMarquee();
    window.addEventListener('resize', syncMarquee);
    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', syncMarquee);
    }
    if (typeof mobile.addEventListener === 'function') {
      mobile.addEventListener('change', syncMarquee);
    }
  });
}

function initCollapsibleSections() {
  document.querySelectorAll('[data-collapse]').forEach(function(root) {
    var toggle = root.querySelector('[data-collapse-toggle]');
    if (!toggle) return;
    root.classList.add('is-collapsible');
    toggle.addEventListener('click', function() {
      var expanded = root.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var more = toggle.querySelector('[data-collapse-more]');
      var less = toggle.querySelector('[data-collapse-less]');
      if (more) more.hidden = expanded;
      if (less) less.hidden = !expanded;
    });
  });
}

function syncVariantFromGalleryIndex(index) {
  var data = getProductVariantsData();
  if (!data || !data.hasVariants || !data.mediaVariants || !data.mediaVariants.length) return;
  var entry = data.mediaVariants.find(function(item) {
    return item.index === index && item.variant_id;
  });
  if (!entry || !entry.variant_id) return;
  var currentId = getSelectedProductVariantId();
  if (currentId === entry.variant_id) return;

  // If the currently selected variant already uses this slide as its featured
  // media, keep that selection (shared images must not jump to another option).
  if (currentId && data.variants && data.variants.length) {
    var current = data.variants.find(function(v) { return v.id === currentId; });
    if (current && Number(current.featured_media_index) === Number(index)) {
      return;
    }
  }

  applyProductVariant(entry.variant_id, { skipGallery: true });
}

function parseVariantSpecParts(variant) {
  var src = ((variant && (variant.option1 || variant.title)) || '').trim();
  if (!src) return { size: '', propagation: '' };
  var parts = src.split(/\s*[|｜]\s*/);
  return {
    size: parts.length >= 2 ? parts[1].trim() : '',
    propagation: parts.length >= 3 ? parts[2].trim() : ''
  };
}

function formatProductSizeWithInches(value) {
  var size = String(value || '').trim();
  if (!size) return '';

  var measurementPattern = /([HW])?(\s*)(\d+(?:\.\d+)?)(?:\s*[-–—]\s*(\d+(?:\.\d+)?))?\s*(\+)?\s*c(?:m)?(\+)?(?=$|[^A-Za-z]|[HW](?=\s*\d))/gi;

  function toInches(centimeters) {
    return (parseFloat(centimeters) / 2.54).toFixed(1).replace(/\.0$/, '');
  }

  return size.replace(measurementPattern, function(match, prefix, spacing, minimum, maximum, plusBeforeUnit, plusAfterUnit, offset, source) {
    var label = '';
    var metricValue = minimum;
    var imperialValue = toInches(minimum);
    var hasPlus = plusBeforeUnit || plusAfterUnit;

    if (prefix) {
      var textBeforePrefix = source.slice(0, offset);
      var isDimensionPrefix = offset === 0 || !/[A-Za-z]$/.test(textBeforePrefix) || /cm$/i.test(textBeforePrefix);

      if (isDimensionPrefix) {
        label = prefix.toLowerCase() === 'w' ? 'width：' : 'high：';
        spacing = '';
      } else {
        label = prefix;
      }
    }

    if (maximum) {
      metricValue += '-' + maximum;
      imperialValue += '-' + toInches(maximum);
    }

    if (hasPlus) {
      metricValue += '+';
      imperialValue += '+';
    }

    return label + spacing + metricValue + 'cm (' + imperialValue + 'in)';
  });
}

function updateProductSpecFromVariant(variant) {
  var data = getProductVariantsData();
  var parts = parseVariantSpecParts(variant);
  var sizeEl = document.querySelector('[data-product-spec-size]');
  var propEl = document.querySelector('[data-product-spec-propagation]');
  var weightEl = document.querySelector('[data-product-spec-weight]');
  var weightRow = document.querySelector('[data-product-spec-weight-row]');
  if (sizeEl) {
    var sizeValue = parts.size || (data && data.fallbackSize) || '';
    var formattedSize = sizeValue;
    if (!sizeEl.hasAttribute('data-product-spec-harvest') && !(data && data.is_seed)) {
      formattedSize = formatProductSizeWithInches(sizeValue);
    }
    if (sizeEl.hasAttribute('data-model-spec-size')) {
      formattedSize = formattedSize.replace(/(?:width|high)：/gi, '');
    }
    sizeEl.textContent = formattedSize;
  }
  if (propEl) {
    propEl.textContent = parts.propagation || (data && data.fallbackPropagation) || '';
  }
  if (weightEl) {
    var modelWeight = weightEl.hasAttribute('data-model-spec-weight');
    weightEl.textContent = modelWeight ? (variant.weight_kg || '') : (variant.weight_formatted || '');
  }
  if (weightRow) {
    var modelRow = weightRow.querySelector('[data-model-spec-weight]');
    weightRow.hidden = modelRow ? !variant.weight_kg : !variant.weight_formatted;
  }
  updateModelStock(variant);
}

function updateModelStock(variant) {
  var el = document.querySelector('[data-model-stock]');
  var sep = document.querySelector('[data-model-stock-sep]');
  if (!el) return;
  if (!variant || !variant.inventory_tracked) {
    el.textContent = '';
    if (sep) sep.hidden = true;
    return;
  }
  var qty = parseInt(variant.inventory_quantity, 10);
  if (isNaN(qty)) qty = 0;
  if (sep) sep.hidden = false;
  el.textContent = qty + ' in stock';
}

function formatSelectionStockHtml(variant) {
  if (!variant || !variant.inventory_tracked) return '';
  var qty = parseInt(variant.inventory_quantity, 10);
  if (isNaN(qty)) qty = 0;
  var qtyHtml = '<span class="product-variants__stock-qty">' + qty + '</span>';
  if (qty === 1) return 'In stock · ' + qtyHtml + ' of ' + qtyHtml;
  if (qty > 1) return 'In stock · ' + qtyHtml + ' available';
  if (variant.available === false) return 'Out of stock';
  return '';
}

function updateSelectionStock(variant) {
  var el = document.querySelector('[data-product-selection-stock]');
  if (!el) return;
  var html = formatSelectionStockHtml(variant);
  if (!html) {
    el.textContent = '';
    return;
  }
  el.innerHTML = html;
}

function applyProductVariant(variantId, options) {
  var opts = options || {};
  var data = getProductVariantsData();
  if (!data) return;
  var variant = data.variants.find(function(v) { return v.id === variantId; });
  if (!variant) return;

  if (!opts.skipUrl) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', String(variantId));
    history.replaceState({ variantId: variantId }, '', url);
  }

  document.querySelectorAll('[data-variant-label]').forEach(function(label) {
    var input = label.querySelector('input[name="id"]');
    var isActive = input && parseInt(input.value, 10) === variantId;
    var isAvailable = label.getAttribute('data-variant-available') === 'true';
    label.classList.toggle('is-active', isActive);
    label.classList.toggle('is-unavailable', !isAvailable);
    if (input) input.checked = isActive;
  });

  var galleryIndex = variant.featured_media_index || 0;
  var total = parseInt(window._galleryTotal || '1', 10);
  galleryIndex = Math.max(0, Math.min(galleryIndex, total - 1));
  if (!opts.skipGallery && typeof galleryGo === 'function') {
    galleryGo(galleryIndex, { instant: true, skipVariantSync: true });
  }

  var priceEl = document.getElementById('productPrice');
  var compareEl = document.getElementById('productComparePrice');
  var retailEl = document.getElementById('productRetailPrice');
  var retailValueEl = document.getElementById('productRetailPriceValue');
  var showVolumeB2b = productPageIsB2b() && !!(variant.quantity_price_breaks && variant.quantity_price_breaks.length);
  var priceBox = document.getElementById('productPriceBox');
  var b2bTag = document.getElementById('productB2bTag');
  if (priceBox) priceBox.classList.toggle('product-pricebox--b2b', showVolumeB2b);
  if (b2bTag) b2bTag.hidden = !showVolumeB2b;
  if (priceEl && variant.price_formatted) {
    priceEl.textContent = variant.price_formatted;
  }
  if (compareEl) {
    var showCompare = !showVolumeB2b && variant.compare_at_price > variant.price;
    compareEl.hidden = !showCompare;
    if (showCompare) compareEl.textContent = variant.compare_at_price_formatted;
  }
  if (retailEl) {
    var showRetail = showVolumeB2b && variant.compare_at_price > 0;
    retailEl.hidden = !showRetail;
    if (showRetail && retailValueEl && variant.compare_at_price_formatted) {
      retailValueEl.textContent = variant.compare_at_price_formatted;
    }
  }

  renderVolumePricing();
  setProductQty(getProductQty());

  var addBtn = document.getElementById('productAddBtn');
  var addText = document.getElementById('productAddBtnText');
  var buyBtn = document.getElementById('productBuyBtn');
  var buyError = document.getElementById('productBuyError');
  var acceleratedCheckout = document.getElementById('productAcceleratedCheckout');
  var b2bPricingProperty = document.getElementById('productB2bPricingProperty');
  if (addBtn) {
    addBtn.disabled = !variant.available;
    if (addText) {
      addText.textContent = variant.available
        ? (addBtn.getAttribute('data-add-label') || 'Add to Cart')
        : (addBtn.getAttribute('data-sold-label') || 'Sold Out');
    }
  }
  if (buyBtn) {
    buyBtn.hidden = !variant.available;
    buyBtn.disabled = !variant.available || buyBtn.getAttribute('aria-busy') === 'true';
  }
  if (buyError) buyError.hidden = true;
  if (acceleratedCheckout) acceleratedCheckout.hidden = !variant.available;
  if (b2bPricingProperty) b2bPricingProperty.disabled = !showVolumeB2b;

  updateProductSpecFromVariant(variant);
  updateSelectionStock(variant);
}

function initProductVariantPicker() {
  var picker = document.querySelector('[data-variant-picker]');
  if (!picker) return;

  picker.addEventListener('change', function(e) {
    var input = e.target.closest('input[name="id"]');
    if (!input) return;
    applyProductVariant(parseInt(input.value, 10));
  });

  window.addEventListener('popstate', function() {
    var id = getSelectedProductVariantId();
    if (id) applyProductVariant(id, { skipUrl: true });
  });
}

function lockProductVariantFromUrlOrChecked() {
  var id = getSelectedProductVariantId();
  if (!id) return;
  var params = new URLSearchParams(window.location.search);
  var fromUrl = !!params.get('variant');
  applyProductVariant(id, { skipUrl: fromUrl });
}


// === Product description: KaTeX for LaTeX in rich text ===
var katexAssetBase = 'https://cdn.jsdelivr.net/npm/katex@0.16.11/dist';
var katexLoadPromise = null;

function loadProductDescStylesheet(href) {
  if (document.querySelector('link[href="' + href + '"]')) {
    return Promise.resolve();
  }
  return new Promise(function(resolve) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.crossOrigin = 'anonymous';
    link.onload = resolve;
    link.onerror = resolve;
    document.head.appendChild(link);
  });
}

function loadProductDescScript(src) {
  return new Promise(function(resolve, reject) {
    var script = document.createElement('script');
    script.src = src;
    script.crossOrigin = 'anonymous';
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

function ensureProductDescKaTeX() {
  if (typeof renderMathInElement === 'function') {
    return Promise.resolve();
  }
  if (katexLoadPromise) {
    return katexLoadPromise;
  }
  katexLoadPromise = loadProductDescStylesheet(katexAssetBase + '/katex.min.css')
    .then(function() {
      return loadProductDescScript(katexAssetBase + '/katex.min.js');
    })
    .then(function() {
      return loadProductDescScript(katexAssetBase + '/contrib/auto-render.min.js');
    });
  return katexLoadPromise;
}

function renderProductDescMath(content) {
  if (!content || !/\$/.test(content.textContent)) {
    return Promise.resolve();
  }
  return ensureProductDescKaTeX()
    .then(function() {
      if (typeof renderMathInElement !== 'function') return;
      renderMathInElement(content, {
        delimiters: [
          { left: '$$', right: '$$', display: true },
          { left: '$', right: '$', display: false }
        ],
        throwOnError: false
      });
    })
    .catch(function() {
      // 公式库加载失败时仍展示原文，不影响正文阅读
    });
}

// === Product description expand / collapse ===
(function() {
  var roots = document.querySelectorAll('[data-product-desc-expand]');
  if (!roots.length) return;

  roots.forEach(function(root) {
    var inner = root.querySelector('[data-desc-inner]');
    var content = root.querySelector('[data-desc-content]');
    var toggle = root.querySelector('[data-desc-toggle]');
    var moreLabel = root.querySelector('[data-desc-more]');
    var lessLabel = root.querySelector('[data-desc-less]');
    if (!inner || !content || !toggle) return;

    var collapsedMax = parseInt(root.getAttribute('data-collapsed-max') || '220', 10);

    function setExpanded(expanded) {
      root.classList.toggle('is-expanded', expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (moreLabel) moreLabel.hidden = expanded;
      if (lessLabel) lessLabel.hidden = !expanded;

      if (expanded) {
        inner.style.maxHeight = content.scrollHeight + 'px';
        window.setTimeout(function() {
          if (root.classList.contains('is-expanded')) {
            inner.style.maxHeight = 'none';
          }
        }, 460);
      } else {
        inner.style.maxHeight = content.scrollHeight + 'px';
        window.requestAnimationFrame(function() {
          inner.style.maxHeight = collapsedMax + 'px';
        });
      }
    }

    function measure() {
      var wasExpanded = root.classList.contains('is-expanded');
      inner.style.maxHeight = 'none';
      root.classList.remove('is-collapsible', 'is-expanded');
      toggle.hidden = true;
      if (moreLabel) moreLabel.hidden = false;
      if (lessLabel) lessLabel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');

      if (content.scrollHeight <= collapsedMax) {
        inner.style.maxHeight = '';
        return;
      }

      root.classList.add('is-collapsible');
      toggle.hidden = false;

      if (wasExpanded) {
        root.classList.add('is-expanded');
        toggle.setAttribute('aria-expanded', 'true');
        if (moreLabel) moreLabel.hidden = true;
        if (lessLabel) lessLabel.hidden = false;
        inner.style.maxHeight = 'none';
      } else {
        inner.style.maxHeight = collapsedMax + 'px';
      }
    }

    toggle.addEventListener('click', function() {
      var willExpand = !root.classList.contains('is-expanded');
      if (willExpand) {
        inner.style.maxHeight = collapsedMax + 'px';
        window.requestAnimationFrame(function() {
          setExpanded(true);
        });
      } else {
        inner.style.maxHeight = content.scrollHeight + 'px';
        window.requestAnimationFrame(function() {
          setExpanded(false);
        });
      }
    });

    function bindMeasureAfterContentReady() {
      measure();

      content.querySelectorAll('img').forEach(function(img) {
        if (!img.complete) {
          img.addEventListener('load', measure, { once: true });
        }
      });
    }

    renderProductDescMath(content).then(bindMeasureAfterContentReady);

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(measure, 200);
    });
  });
})();


function initSeedGuide(scope) {
  var root = scope && scope.querySelectorAll ? scope : document;
  var sections = root.querySelectorAll('[data-seed-guide]');
  if (root.matches && root.matches('[data-seed-guide]')) {
    sections = [root].concat(Array.prototype.slice.call(sections));
  }
  Array.prototype.forEach.call(sections, function(section) {
    if (section.dataset.seedGuideBound === 'true') return;
    section.dataset.seedGuideBound = 'true';
    section.addEventListener('toggle', function(event) {
      var panel = event.target;
      if (!panel.open || !panel.hasAttribute('data-seed-guide-panel')) return;
      var panels = section.querySelectorAll('[data-seed-guide-panel]');
      for (var i = 0; i < panels.length; i++) {
        if (panels[i] !== panel) panels[i].open = false;
      }
    }, true);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initProductAnnouncement(document);
  initSeedGuide(document);

  initProductQtyInput();
  initSeedPromoQty();
  initBuyNow();

  if (document.querySelector('[data-variant-picker]')) {
    initProductVariantPicker();
  }

  var galleryRoot = document.getElementById('productGallery');
  if (galleryRoot) {
    initProductGalleryMediaLoading(galleryRoot);
    window._galleryTotal = parseInt(galleryRoot.getAttribute('data-gallery-total') || '1', 10);
    var initialGalleryIndex = parseInt(galleryRoot.getAttribute('data-gallery-initial-index') || '0', 10);
    var variantData = getProductVariantsData();
    if (variantData && variantData.variants && variantData.variants.length) {
      initialGalleryIndex = getProductVariantGalleryIndex();
    }
    window._galleryIndex = initialGalleryIndex;

    updateGallery({ instant: initialGalleryIndex > 0, skipVariantSync: true });

    initProductGalleryThumbsToggle();
    initProductGalleryThumbsScrollHint();
  }

  initCollapsibleSections();
  initModelPanels(document);
  initModelRelated(document);

  // After gallery init: force the variant from ?variant= / checked radio so
  // mediaVariants ownership of a shared image cannot switch to another option.
  if (document.querySelector('[data-variant-picker]') || document.getElementById('productForm')) {
    lockProductVariantFromUrlOrChecked();
    renderVolumePricing();
    setProductQty(getProductQty());
  }
});

document.addEventListener('shopify:section:load', function(event) {
  initProductAnnouncement(event.target);
  initSeedGuide(event.target);
  initModelPanels(event.target);
  initModelRelated(event.target);
});

function initProductAnnouncement(scope) {
  var root = scope && scope.querySelector
    ? (scope.matches && scope.matches('[data-product-announcement]')
      ? scope
      : scope.querySelector('[data-product-announcement]'))
    : null;
  if (!root || root.getAttribute('data-product-announcement-initialized') === 'true') return;

  var items = root.querySelectorAll('[data-product-announcement-item]');
  if (!items.length) return;

  root.setAttribute('data-product-announcement-initialized', 'true');
  if (items.length < 2) return;

  var prevBtn = root.querySelector('[data-product-announcement-prev]');
  var nextBtn = root.querySelector('[data-product-announcement-next]');
  var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);
  var index = 0;
  var timer = null;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  items.forEach(function(item, itemIndex) {
    if (item.classList.contains('is-active')) index = itemIndex;
  });

  function setActive(nextIndex) {
    index = (nextIndex + items.length) % items.length;
    items.forEach(function(item, itemIndex) {
      var active = itemIndex === index;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-hidden', active ? 'false' : 'true');
      item.inert = !active;
    });
  }

  function stop() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  function start() {
    if (reducedMotion) return;
    stop();
    timer = window.setInterval(function() {
      setActive(index + 1);
    }, interval);
  }

  function go(delta) {
    setActive(index + delta);
    start();
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function() { go(-1); });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function() { go(1); });
  }

  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', start);
  document.addEventListener('shopify:section:unload', function onUnload(event) {
    if (event.target.contains(root) || event.target === root) {
      stop();
      document.removeEventListener('shopify:section:unload', onUnload);
    }
  });
  start();
}
